module.exports = __webpack_public_path__ + "img/ico-like01-on.f8035ee0.svg";